import Ticket from 'models/Ticket'
import { useParams } from 'react-router-dom'
import { useFetchList } from 'store'
import { useDrawerContext } from 'context/Drawer/DrawerContext'
import TicketCard from 'components/cards/TicketCard/TicketCard'
import NoData from 'components/general/NoData/NoData'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { getDrawerTypeFromTicketType } from 'utils'

const TicketsController = () => {
	const { clinicalProcessId } = useParams()
	const { dispatch } = useDrawerContext()
	const { i18n } = useGlobal()

	const ticketsUri = `/clinical_processes/${clinicalProcessId}/tickets`
	const { contents, isLoading } = useFetchList(
		[ticketsUri],
		[Ticket.fromJSON]
	)

	const [ticketsContent = []] = contents || []

	const tickets = ticketsContent.map((ticket) => {
		return {
			...ticket,
			// $cardLabels: cardLabels,
			// $layout: cardLayout,
			// $displayAnchorLink: true,
			// $highlight:
			// 	anchorTag === json.anchorId || json.id === selectedRequisition,
			$action: getDrawerTypeFromTicketType(ticket.ticketType)
				? () => {
						dispatch({
							action: 'OPEN_DRAWER',
							payload: {
								type: getDrawerTypeFromTicketType(
									ticket.ticketType
								),
								data: {
									...ticket,
								},
							},
						})
				  }
				: null,
		}
	})

	return (
		<div>
			{!tickets.length ? (
				<NoData
					applyMaxWidth
					paddings={['normal', 'normal']}
					message={
						isLoading
							? i18n`Loading`
							: i18n`This process has no extra data to show.`
					}
				/>
			) : (
				(tickets ?? []).map((item) => (
					<TicketCard key={item.id} data={item} />
				))
			)}
		</div>
	)
}

export default TicketsController
